module.exports = __webpack_public_path__ + "img/arrow-right-orange.a1264bef.svg";